import React from 'react';
import ModuleLayout from '../../layouts/ModuleLayout';
import { StockAdjustmentList } from '../../components/Admin/Inventory/StockAdjustments';

export default function StockAdjustmentsPage() {
  return (
    <ModuleLayout>
      <StockAdjustmentList />
    </ModuleLayout>
  );
}
